/**
 * Extracts the creative ID (UUID) from a campaign CMS URL.
 *
 * Expected URL format:
 * https://beta.console.harmony.a2z.com/content-symphony/NA/creatives/summary/{creativeId}
 *
 * @param campaignCmsUrl - The full campaign CMS URL
 * @returns The creative ID (last path segment) or the original string if extraction fails
 */
export const extractCreativeIdFromUrl = (campaignCmsUrl: string): string => {
  try {
    const url = new URL(campaignCmsUrl);
    const segments = url.pathname.split('/').filter(Boolean);
    return segments[segments.length - 1] || campaignCmsUrl;
  } catch {
    // If it's not a valid URL, return as-is (might already be a bare ID)
    return campaignCmsUrl;
  }
};
